import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { Caixa } from '../api/dto/caixa';
import { Paginador } from '../api/dto/paginacao/paginador';
import { ResumoCaixaGerenciar } from '../api/dto/resumo-caixa-gerenciar';
import { DetalharContaCaixaGerenciar } from '../api/dto/detalhar-conta-caixa-gerenciar';
import { CaixaGerenciar } from '../api/dto/caixa-gerenciar';
import { DetalharComandaGerenciar } from '../api/dto/detalhar-comanda-gerenciar';
import { DespesaCaixaGerenciar } from '../api/dto/despesa-caixa-gerenciar';
import { RelatorioTransferenciaCaixa } from '../api/dto/relatorio-transferencia-caixa';

@Injectable({
    providedIn: 'root'
})
export class CaixaService{

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'caixas/';

    buscarPorId(idCaixa?: number): Observable<Caixa> {
        return this.http.get<Caixa>(this.url + idCaixa);
    }
    
    listarAbertosPorEmpresa(empresaId?: number): Observable<Caixa[]>  {
        return this.http.get<Caixa[]>(this.url + "empresa/" + empresaId + "/status/aberto");
    }

    listarPorEmpresaPaginado(empresaId?: number, status?: string, numeroPagina?: number,
        data?: Date, tamanho?: number, ordenacao?: string): Observable<Paginador<CaixaGerenciar>> {
        let params = new HttpParams();
        if(data) {
            params = params.set('data', data.toISOString());
        }
        if(tamanho) {
            params = params.set('tamanho', tamanho);
        }
        if(ordenacao) {
            params = params.set('sort', ordenacao);
        }

        return this.http.get<Paginador<CaixaGerenciar>>(this.url + "empresa/" + empresaId + "/status/" 
            + status + "/numero-pagina/" + numeroPagina, {params});
    }

    listarResumoCaixa(empresaId?: number, dataCaixa?: Date): Observable<ResumoCaixaGerenciar> {
        return this.http.get<ResumoCaixaGerenciar>(this.url + "empresa/" + empresaId + "/caixa/" + dataCaixa );
    }

    listarDespesasCaixa(empresaId?: number, dataCaixa?: Date): Observable<DespesaCaixaGerenciar[]> {
        return this.http.get<DespesaCaixaGerenciar[]>(this.url + "empresa/" + empresaId + "/caixa/" + dataCaixa + "/despesas" );
    }

    listarTransferenciasCaixa(empresaId?: number, dataCaixa?: Date): Observable<RelatorioTransferenciaCaixa[]> {
        return this.http.get<RelatorioTransferenciaCaixa[]>(this.url + "empresa/" + empresaId + "/caixa/" + dataCaixa + "/transferencias" );
    }

    consultarDetalhesPagamentoPorTipoContaEData(empresaId?: number, dataCaixa?: Date,
             tipoConta?: string): Observable<DetalharContaCaixaGerenciar[]> {
        return this.http.get<DetalharContaCaixaGerenciar[]>(this.url + "empresa/" + 
            empresaId + "/caixa/" + dataCaixa + "/tipo-conta/" + tipoConta );
    }

    consultarDetalhesComandaPorEmpresaEDataCaixa(empresaId?: number, dataCaixa?: Date): Observable<DetalharComandaGerenciar[]> {
        return this.http.get<DetalharComandaGerenciar[]>(this.url + "empresa/" + 
            empresaId + "/caixa/" + dataCaixa + "/detalhe-comanda/" );
    }

    abrirCaixa(caixaDto?: Caixa): Observable<Caixa> {
        return this.http.post<Caixa>(this.url + 'abrir-caixa', caixaDto)
    }

    abrirCaixaGerenciar(caixaDto?: Caixa): Observable<Caixa> {
        return this.http.post<Caixa>(this.url + 'abrir-caixa-gerenciar', caixaDto)
    }

    fecharCaixaAdministrativo(caixaDto?: Caixa): Observable<void> {
        return this.http.post<void>(this.url + 'fechar-caixa-administrativo', caixaDto)
    }

    reabrirCaixaAdministrativo(caixaDto?: Caixa): Observable<void> {
        return this.http.post<void>(this.url + 'reabrir-caixa-administrativo', caixaDto)
    }

    alterarDataCaixaAdministrativo(caixaDto?: CaixaGerenciar): Observable<void> {
        return this.http.post<void>(this.url + 'alterar-caixa-administrativo', caixaDto)
    }
    
}